export const calendarConfiguratorI18NDe = {
    showAll: "Alle anzeigen",
    hideAll: "Alle ausblenden",
    active: "Alle anzeigen",
    addTeam: "Team hinzufügen",
    allTeams: "Alle Teams",
    myTeams: "Meine Teams",
};
